import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App";
import "./index.css";

// vite-react-ssg attaches a synthetic data-loader to every route in production
// (SSR/SSG) that fetches a build-hashed manifest JSON whose hash rotates on every
// deploy. None of our routes use loader data, so seed an empty manifest to skip
// that fetch entirely. Without this, a browser holding stale cached HTML (which
// references an old build hash whose JSON was deleted by a later deploy) fetches a
// 404 that the static host answers with index.html, making .json() throw
// "Unexpected token '<', \"<!DOCTYPE \"... is not valid JSON" and crashing every page.
// NOTE: If marketing routes ever define real react-router `loader`s, remove this
// seed — it suppresses vite-react-ssg's static-loader data and loaders would get null.
if (typeof window !== "undefined") {
  const w = window as unknown as {
    __VITE_REACT_SSG_STATIC_LOADER_MANIFEST__?: Record<string, string>;
  };
  if (!w.__VITE_REACT_SSG_STATIC_LOADER_MANIFEST__) {
    w.__VITE_REACT_SSG_STATIC_LOADER_MANIFEST__ = {};
  }
}

export const createRoot = ViteReactSSG({
  routes,
  basename: import.meta.env.BASE_URL,
});
